class ShopTheFeedButton extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.config = JSON.parse(this.dataset.config);
        this.shopTheLookViewer = document.querySelector('hoculus-shop-the-feed-viewer');

        this.addEventListener('click', this.onClick.bind(this));
    }

    onClick() {
        this.shopTheLookViewer.switchVideo(this.config.video);
        this.shopTheLookViewer.switchProduct(this.config.product, this.config.productUrl, this.config.productImage, this.config.productHandle, this.config.feedUrl, this.config.feedTextCta);
        document.body.style.overflow = 'hidden';
    }
}

class ShopTheFeedViewer extends HTMLElement {
    constructor() {
        super();

        document.body.appendChild(this);
        this.classList.add('hoculus-shop-the-feed-viewer', 'hidden', 'video-running');

        this.locales = JSON.parse(this.dataset.locales);

        this.icons = {
            close: '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.055 16.594a.662.662 0 0 1-.899 0L10 11.398l-5.195 5.196a.662.662 0 0 1-.899 0 .662.662 0 0 1 0-.899L9.102 10.5 3.906 5.344a.662.662 0 0 1 0-.899.662.662 0 0 1 .899 0L10 9.641l5.156-5.196a.662.662 0 0 1 .899 0 .662.662 0 0 1 0 .899L10.859 10.5l5.196 5.195a.662.662 0 0 1 0 .899Z" style="fill: #FFFFFF;"></path></svg>',
            share: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.26 14.978a10.985 10.985 0 0 1 10.216-8.546l.955-.044V3.047a.047.047 0 0 1 .081-.033L18.95 9.45l-.057.057-6.38 6.38a.048.048 0 0 1-.033.014.047.047 0 0 1-.047-.047v-3.456l-.784-.173A11.7 11.7 0 0 0 1.26 14.978Z" stroke="#fff" stroke-width="2"></path></svg>',
            play: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6"><path fill-rule="evenodd" d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z" clip-rule="evenodd" /></svg>',
            pause: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6"><path fill-rule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clip-rule="evenodd" /></svg>',
            mute: '<svg width="20" height="20" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.508.867C12.313.79 12.156.79 12 .79c-.313 0-.625.078-.86.313L5.868 5.75H2.625C1.57 5.75.75 6.61.75 7.625v3.71c0 1.017.82 1.837 1.875 1.837h3.242l5.274 4.687c.234.196.546.313.859.313.156 0 .313-.04.508-.117.43-.196.703-.664.703-1.133V2c0-.469-.274-.938-.703-1.133Zm-1.133 14.766-4.766-4.258H2.625v-3.71h3.984l4.766-4.259v12.227ZM20.789 9.5l1.836-1.836c.39-.39.39-.976 0-1.328-.352-.39-.938-.39-1.328 0L19.5 8.21l-1.875-1.875c-.39-.352-.977-.352-1.328 0-.39.39-.39.976 0 1.328L18.133 9.5l-1.836 1.836c-.39.39-.39.976 0 1.328.351.39.937.39 1.328 0l1.875-1.836 1.836 1.836c.352.39.937.39 1.289 0 .39-.351.39-.937 0-1.328L20.789 9.5Z" fill="#fff"></path></svg>',
            unmute: '<svg width="20" height="17" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.758.867A1.349 1.349 0 0 0 11.25.75c-.313 0-.625.117-.86.352L5.118 5.75H1.875C.82 5.75 0 6.61 0 7.625v3.71c0 1.017.82 1.837 1.875 1.837h3.242l5.274 4.687c.234.313.546.391.859.391.156 0 .313 0 .508-.078.43-.235.742-.664.742-1.172V2c0-.469-.313-.938-.742-1.133Zm-1.133 14.766-4.766-4.258H1.875v-3.71h3.984l4.766-4.259v12.227Zm5.469-9.024a1.053 1.053 0 0 0-.586-.195.962.962 0 0 0-.742.352.942.942 0 0 0 .156 1.328c.43.351.703.86.703 1.406a1.85 1.85 0 0 1-.703 1.445.942.942 0 0 0-.156 1.328.962.962 0 0 0 .742.352c.195 0 .43-.078.586-.195.898-.742 1.406-1.797 1.406-2.93 0-1.094-.508-2.148-1.406-2.89Zm2.383-2.89c-.196-.117-.391-.196-.625-.196-.274 0-.508.118-.704.352-.351.39-.273.977.118 1.328 1.328 1.055 2.109 2.656 2.109 4.297 0 1.68-.781 3.281-2.11 4.336-.39.351-.468.937-.117 1.328.196.234.43.352.704.352.234 0 .43-.079.625-.196 1.757-1.445 2.773-3.554 2.773-5.82 0-2.227-1.016-4.336-2.773-5.781Z" fill="#fff"></path></svg>',
            bag: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6"><path fill-rule="evenodd" d="M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 0 0 4.25 22.5h15.5a1.875 1.875 0 0 0 1.865-2.071l-1.263-12a1.875 1.875 0 0 0-1.865-1.679H16.5V6a4.5 4.5 0 1 0-9 0ZM12 3a3 3 0 0 0-3 3v.75h6V6a3 3 0 0 0-3-3Zm-3 8.25a3 3 0 1 0 6 0v-.75a.75.75 0 0 1 1.5 0v.75a4.5 4.5 0 1 1-9 0v-.75a.75.75 0 0 1 1.5 0v.75Z" clip-rule="evenodd" /></svg>',
            facebook: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M240 363.3L240 576L356 576L356 363.3L442.5 363.3L460.5 265.5L356 265.5L356 230.9C356 179.2 376.3 159.4 428.7 159.4C445 159.4 458.1 159.8 465.7 160.6L465.7 71.9C451.4 68 416.4 64 396.2 64C289.3 64 240 114.5 240 223.4L240 265.5L174 265.5L174 363.3L240 363.3z"/></svg>',
            linkedin: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M512 96L127.9 96C110.3 96 96 110.5 96 128.3L96 511.7C96 529.5 110.3 544 127.9 544L512 544C529.6 544 544 529.5 544 511.7L544 128.3C544 110.5 529.6 96 512 96zM231.4 480L165 480L165 266.2L231.5 266.2L231.5 480L231.4 480zM198.2 160C219.5 160 236.7 177.2 236.7 198.5C236.7 219.8 219.5 237 198.2 237C176.9 237 159.7 219.8 159.7 198.5C159.7 177.2 176.9 160 198.2 160zM480.3 480L413.9 480L413.9 376C413.9 351.2 413.4 319.3 379.4 319.3C344.8 319.3 339.5 346.3 339.5 374.2L339.5 480L273.1 480L273.1 266.2L336.8 266.2L336.8 295.4L337.7 295.4C346.6 278.6 368.3 260.9 400.6 260.9C467.8 260.9 480.3 305.2 480.3 362.8L480.3 480z"/></svg>',
            whatsapp: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M476.9 161.1C435 119.1 379.2 96 319.9 96C197.5 96 97.9 195.6 97.9 318C97.9 357.1 108.1 395.3 127.5 429L96 544L213.7 513.1C246.1 530.8 282.6 540.1 319.8 540.1L319.9 540.1C442.2 540.1 544 440.5 544 318.1C544 258.8 518.8 203.1 476.9 161.1zM319.9 502.7C286.7 502.7 254.2 493.8 225.9 477L219.2 473L149.4 491.3L168 423.2L163.6 416.2C145.1 386.8 135.4 352.9 135.4 318C135.4 216.3 218.2 133.5 320 133.5C369.3 133.5 415.6 152.7 450.4 187.6C485.2 222.5 506.6 268.8 506.5 318.1C506.5 419.9 421.6 502.7 319.9 502.7zM421.1 364.5C415.6 361.7 388.3 348.3 383.2 346.5C378.1 344.6 374.4 343.7 370.7 349.3C367 354.9 356.4 367.3 353.1 371.1C349.9 374.8 346.6 375.3 341.1 372.5C308.5 356.2 287.1 343.4 265.6 306.5C259.9 296.7 271.3 297.4 281.9 276.2C283.7 272.5 282.8 269.3 281.4 266.5C280 263.7 268.9 236.4 264.3 225.3C259.8 214.5 255.2 216 251.8 215.8C248.6 215.6 244.9 215.6 241.2 215.6C237.5 215.6 231.5 217 226.4 222.5C221.3 228.1 207 241.5 207 268.8C207 296.1 226.9 322.5 229.6 326.2C232.4 329.9 268.7 385.9 324.4 410C359.6 425.2 373.4 426.5 391 423.9C401.7 422.3 423.8 410.5 428.4 397.5C433 384.5 433 373.4 431.6 371.1C430.3 368.6 426.6 367.2 421.1 364.5z"/></svg>',
            twitter: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M523.4 215.7C523.7 220.2 523.7 224.8 523.7 229.3C523.7 368 418.1 527.9 225.1 527.9C165.6 527.9 110.4 510.7 64 480.8C72.4 481.8 80.6 482.1 89.3 482.1C138.4 482.1 183.5 465.5 219.6 437.3C173.5 436.3 134.8 406.1 121.5 364.5C128 365.5 134.5 366.1 141.3 366.1C150.7 366.1 160.1 364.8 168.9 362.5C120.8 352.8 84.8 310.5 84.8 259.5L84.8 258.2C98.8 266 115 270.9 132.2 271.5C103.9 252.7 85.4 220.5 85.4 184.1C85.4 164.6 90.6 146.7 99.7 131.1C151.4 194.8 229 236.4 316.1 240.9C314.5 233.1 313.5 225 313.5 216.9C313.5 159.1 360.3 112 418.4 112C448.6 112 475.9 124.7 495.1 145.1C518.8 140.6 541.6 131.8 561.7 119.8C553.9 144.2 537.3 164.6 515.6 177.6C536.7 175.3 557.2 169.5 576 161.4C561.7 182.2 543.8 200.7 523.4 215.7z"/></svg>',
            copy: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M451.5 160C434.9 160 418.8 164.5 404.7 172.7C388.9 156.7 370.5 143.3 350.2 133.2C378.4 109.2 414.3 96 451.5 96C537.9 96 608 166 608 252.5C608 294 591.5 333.8 562.2 363.1L491.1 434.2C461.8 463.5 422 480 380.5 480C294.1 480 224 410 224 323.5C224 322 224 320.5 224.1 319C224.6 301.3 239.3 287.4 257 287.9C274.7 288.4 288.6 303.1 288.1 320.8C288.1 321.7 288.1 322.6 288.1 323.4C288.1 374.5 329.5 415.9 380.6 415.9C405.1 415.9 428.6 406.2 446 388.8L517.1 317.7C534.4 300.4 544.2 276.8 544.2 252.3C544.2 201.2 502.8 159.8 451.7 159.8zM307.2 237.3C305.3 236.5 303.4 235.4 301.7 234.2C289.1 227.7 274.7 224 259.6 224C235.1 224 211.6 233.7 194.2 251.1L123.1 322.2C105.8 339.5 96 363.1 96 387.6C96 438.7 137.4 480.1 188.5 480.1C205 480.1 221.1 475.7 235.2 467.5C251 483.5 269.4 496.9 289.8 507C261.6 530.9 225.8 544.2 188.5 544.2C102.1 544.2 32 474.2 32 387.7C32 346.2 48.5 306.4 77.8 277.1L148.9 206C178.2 176.7 218 160.2 259.5 160.2C346.1 160.2 416 230.8 416 317.1C416 318.4 416 319.7 416 321C415.6 338.7 400.9 352.6 383.2 352.2C365.5 351.8 351.6 337.1 352 319.4C352 318.6 352 317.9 352 317.1C352 283.4 334 253.8 307.2 237.5z"/></svg>'
        }
    }

    connectedCallback() {

        this.initHTML();
        this.initSocialHTML();

        this.selectElement();

        this.closeButton.addEventListener('click', this.onClose.bind(this));
        this.playPauseButton.addEventListener('click', this.onPlayPause.bind(this));
        this.audioButton.addEventListener('click', this.onAudioToggle.bind(this));

        this.shareButton.addEventListener('click', this.onShare.bind(this));
        this.shareCloseButton.addEventListener('click', this.onShareClose.bind(this));
        this.shareCopyButton.addEventListener('click', this.onCopy.bind(this));

        const shopTheFeedParam = new URL(window.location.href).searchParams.get('shop-the-feed');
        if (shopTheFeedParam) {
            this.onOpenSharedVideo(shopTheFeedParam);
        }
    }

    initHTML() {
        this.insertAdjacentHTML('afterbegin', `
            <div data-shop-the-feed-video></div>
            <div class="hoculus-shop-the-feed-notifications" data-shop-the-feed-notifications></div>
            <div class="hoculus-shop-the-feed__controls">
                <div class="hoculus-shop-the-feed__controls-top">
                    <button class="hoculus-shop-the-feed-button" data-shop-the-feed-close>
                        ${this.icons.close}
                    </button>
                    <button class="hoculus-shop-the-feed-button" data-shop-the-feed-share>
                        ${this.icons.share}
                    </button>
                </div>

                <div class="hoculus-shop-the-feed__controls-bottom">
                    <div class="hoculus-shop-the-feed__controls-bottom-controls">
                        <button class="hoculus-shop-the-feed-button hoculus-shop-the-feed-play-pause-button" data-shop-the-feed-play-pause>
                            ${this.icons.play}
                            ${this.icons.pause}
                        </button>
                        
                        <button class="hoculus-shop-the-feed-button hoculus-shop-the-feed-audio-button" data-shop-the-feed-audio>
                            ${this.icons.unmute}
                            ${this.icons.mute}
                        </button>
                    </div>
                    <div class="hoculus-shop-the-feed__product-placeholder"></div>
                </div>
            </div>
        `);
    }

    initSocialHTML() {
        this.insertAdjacentHTML('beforeend', `
            <div class="hoculus-shop-the-feed-social" data-shop-the-feed-social>
                <div class="hoculus-shop-the-feed-social__header">
                    <h6>${this.locales.share}</h6>
                    <button data-shop-the-feed-social-close>
                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.055 16.594a.662.662 0 0 1-.899 0L10 11.398l-5.195 5.196a.662.662 0 0 1-.899 0 .662.662 0 0 1 0-.899L9.102 10.5 3.906 5.344a.662.662 0 0 1 0-.899.662.662 0 0 1 .899 0L10 9.641l5.156-5.196a.662.662 0 0 1 .899 0 .662.662 0 0 1 0 .899L10.859 10.5l5.196 5.195a.662.662 0 0 1 0 .899Z" style="fill: #000000;"></path></svg>
                    </button>
                </div>

                <div class="hoculus-shop-the-feed-social__list">
                    <a href="https://www.facebook.com/sharer/sharer.php?u=" rel="noopener noreferrer" target="_blank" class="hoculus-shop-the-feed-button">
                        ${this.icons.facebook}
                    </a>
                    <a href="https://www.linkedin.com/sharing/share-offsite/?url=" rel="noopener noreferrer" target="_blank" class="hoculus-shop-the-feed-button">
                        ${this.icons.linkedin}
                    </a>
                    <a href="https://wa.me/?text=" rel="noopener noreferrer" target="_blank" class="hoculus-shop-the-feed-button">
                        ${this.icons.whatsapp}
                    </a>
                    <a href="https://twitter.com/intent/tweet?url=" rel="noopener noreferrer" target="_blank" class="hoculus-shop-the-feed-button">
                        ${this.icons.twitter}
                    </a>
                    <button class="hoculus-shop-the-feed-copy-button" data-shop-the-look-social-copy>
                        ${this.icons.copy}
                        ${this.locales.copy}
                    </button>
                </div>
            </div>    
        `)
    }

    selectElement() {
        this.shopTheFeedVideoWrapper = this.querySelector('[data-shop-the-feed-video]');
        this.shopTheFeedNotifications = this.querySelector('[data-shop-the-feed-notifications]');

        this.shopTheFeedSocial = this.querySelector('[data-shop-the-feed-social]');

        this.closeButton = this.querySelector('[data-shop-the-feed-close]');
        this.shareButton = this.querySelector('[data-shop-the-feed-share]');
        this.playPauseButton = this.querySelector('[data-shop-the-feed-play-pause]');
        this.audioButton = this.querySelector('[data-shop-the-feed-audio]');

        this.shareCloseButton = this.querySelector('[data-shop-the-feed-social-close]');
        this.shareCopyButton = this.querySelector('[data-shop-the-look-social-copy]');
    }

    switchVideo(video, autoplay = false) {
        this.video = document.createElement('video');
        this.video.setAttribute('autoplay', '');
        this.video.setAttribute('loop', '');
        this.video.setAttribute('playsinline', '');

        if (autoplay) {
            this.video.setAttribute('muted', '');
            this.classList.add('video-muted');
        }

        this.video.innerHTML = video.sources.reduce((html, source) => html + `<source src="${source.url}" type="${source.mime_type}">`, '');
        this.shopTheFeedVideoWrapper.innerHTML = '';
        this.shopTheFeedVideoWrapper.appendChild(this.video);

        this.classList.remove('hidden');
    }

    switchProduct(product, productUrl, productImage, productHandle, feedUrl, feedTextCta) {
        this.querySelector('.hoculus-shop-the-feed__product-placeholder').innerHTML =
        (feedUrl.trim().length > 0 && feedTextCta.trim().length > 0) ? 
        ` <div class="hoculus-shop-the-feed__cta">
                <a
                    class="button button--solid"
                    href="${feedUrl}"
                    target="_blank"
                >
                    ${feedTextCta}
                </a>
            </div>
        ` : `<div class="hoculus-shop-the-feed__product">
                <a href="${productUrl}">
                  <img src="${productImage}" width="200" />
                </a>
                <div class="hoculus-shop-the-feed__product-info">
                    <a href="${productUrl}">
                        <h6>${product.name}</h6>
                    </a>
                    <p>
                        ${window.formatMoney(product.price, KROWN.settings.shop_money_format)}
                        ${product.compare_at_price > product.price ? `<span style="text-decoration: line-through;">${window.formatMoney(product.compare_at_price, KROWN.settings.shop_money_format)}</span>` : ''}
                    </p>
                    <product-form data-ajax-cart data-js-product-form>
                        <form method="post" action="/cart/add">
                            <input type="hidden" name="id" value="${product.id}" />
                            <input type="hidden" name="quantity" value="1" />
                            
                            <button type="submit" name="add" class="hoculus-shop-the-feed-buy-button hoculus-shop-the-feed-button" aria-label="Add to cart">
                                ${this.icons.bag}
                            </button>
                        </form>
                    </product-form>
                </div>
            </div>
        `;

        this.productForm?.removeEventListener('add-to-cart', this.onAtc);
        this.productForm = this.querySelector('product-form');
        this.productForm?.addEventListener('add-to-cart', this.onAtc);

        this.switchSocialIcons(productHandle);
    }

    onAtc = () => {
        this.showNotification({ message: this.locales.atcSuccess });
    }

    switchSocialIcons(productHandle) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('shop-the-feed', productHandle);

        this.querySelectorAll('[data-shop-the-feed-social] a')
            .forEach(link => {
                const url = new URL(link.href);
                const firstParam = url.searchParams.keys().next().value;

                if (firstParam) {
                    url.searchParams.set(firstParam, currentUrl.href);
                    link.href = url.toString();
                }
            });

        this.shareCopyButton.setAttribute('data-link', currentUrl);
    }

    onClose() {
        this.video?.pause();
        this.classList.add('hidden');
        this.onShareClose();
        document.body.style.overflow = '';
    }

    onPlayPause() {
        if (this.video.paused) {
            this.video.play();
            this.classList.add('video-running');
        } else {
            this.video.pause();
            this.classList.remove('video-running');
        }
    }

    onAudioToggle() {
        if (this.video.muted) {
            this.video.muted = false;
            this.classList.remove('video-muted')
        } else {
            this.video.muted = true;
            this.classList.add('video-muted');
        }
    }

    onShare() {
        this.shopTheFeedSocial.classList.add('visible');
    }

    onShareClose() {
        this.shopTheFeedSocial.classList.remove('visible');
    }

    onOpenSharedVideo(shopTheFeedParam) {
        const shopTheFeedButton = document.querySelector(`#shop-the-feed-${shopTheFeedParam}`);
        const config = JSON.parse(shopTheFeedButton.dataset.config);

        this.switchVideo(config.video, true);
        this.switchProduct(config.product, config.productImage, config.productHandle);
    }

    async onCopy(event) {
        if (event.target.dataset.link) {
            await navigator.clipboard.writeText(event.target.dataset.link);
            this.showNotification({ message: this.locales.copySuccess });
        }
    }

    showNotification({ message, color = '#1E7F4E', bgColor = '#E6F6EE' }) {
        if (!message) {
            return;
        }

        const notificationEl = document.createElement('div');

        notificationEl.insertAdjacentHTML('beforeend', `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z"/></svg>${message}
        `);

        notificationEl.className = 'hoculus-shop-the-feed-notification';

        notificationEl.style.cssText = `
            color: ${color};
            background-color: ${bgColor};
            border: 1px solid ${color};
        `;

        this.shopTheFeedNotifications.appendChild(notificationEl);

        setTimeout(() => {
            notificationEl.remove();
        }, 5000);
    }
}

customElements.define('hoculus-shop-the-feed-button', ShopTheFeedButton);
customElements.define('hoculus-shop-the-feed-viewer', ShopTheFeedViewer);